import React from "react";
import { useNavigate } from "react-router-dom";
import { api, setToken } from "@/lib/api";
import { useAuth } from "@/lib/auth-context";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const processed = React.useRef(false);

  React.useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      toast.error("Session manquante.");
      nav("/login", { replace: true });
      return;
    }
    const session_id = m[1];
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id });
        setToken(data.access_token);
        await refresh();
        toast.success("Connecté avec Google !");
        window.history.replaceState({}, "", "/profil");
        nav("/profil", { replace: true });
      } catch (e) {
        toast.error("Connexion Google échouée.");
        nav("/login", { replace: true });
      }
    })();
  }, [nav, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="neo-card p-8 bg-white text-center">
        <div className="font-display font-black text-xl">Connexion…</div>
        <p className="text-sm text-neutral-600 mt-1">Tu vas être redirigé·e dans un instant.</p>
      </div>
    </div>
  );
}
